/**
 * Turn FastAPI / Starlette `detail` (string | object | array) into a plain string.
 */
export function formatApiDetail(detail, fallback = "Request failed") {
  if (detail == null || detail === "") return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) =>
        typeof x === "object" && x != null && typeof x.msg === "string"
          ? x.msg
          : String(x)
      )
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail === "object" && typeof detail.msg === "string") {
    return detail.msg;
  }
  try {
    return JSON.stringify(detail);
  } catch {
    return fallback;
  }
}

export function formatAxiosError(err, fallback = "Request failed") {
  return formatApiDetail(err?.response?.data?.detail, err?.message || fallback);
}
